import { ProductType } from '@generated/gql/graphql';
import { FindStatus } from '@src/types/oneTouchSwitching';
import { OTSFormValues } from '@src/types/yourDetails';

const useOTSFlags = (productTypes: ProductType[], otsValues: OTSFormValues) => {
  const canSwitch = productTypes.includes(ProductType.Broadband);

  const isSwitch =
    canSwitch &&
    otsValues.otsHasExistingLine &&
    !otsValues.otsProviderNotListed &&
    otsValues.otsFindStatus === FindStatus.SUCCESS;

  return {
    canSwitch,
    isSwitch,
  };
};

export { useOTSFlags };
